import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appBodDirective]',
    standalone: false
})
export class BodDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
